import { InvestmentRoundingSetting } from './investment-rounding-setting';

export const roundShareCount = (shareCount: number, setting: InvestmentRoundingSetting): number => {
  switch (setting) {
    case InvestmentRoundingSetting.ROUND_DOWN:
      return Math.floor(shareCount);
    case InvestmentRoundingSetting.ROUND_UP:
      return Math.ceil(shareCount);
    default:
      return Math.round(shareCount);
  }
};
